import styled from 'styled-components';

const Tag = styled.span`
  font-size: 0.6em;
  padding: 2px 6px;
  margin: 0px 10px;
  background: #71A33C;
  font-weight: 900;
  color: white;
  border-radius: 4px;
  border: none;
  white-space: nowrap;
  width: fit-content;
`

export default Tag